import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import CourseCard from '../components/CourseCard';
import { enrollmentsService, lessonsService, lessonProgressService } from '../config/supabase';
import '../styles/DashboardPage.css';

const DashboardPage = () => {
  const { isAdmin } = useAuth();
  const [courses, setCourses] = useState([]);
  const [progressMap, setProgressMap] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCourses = async () => {
      try {
        setLoading(true);
        const data = await enrollmentsService.getMyCourses();
        const enrolled = data || [];
        setCourses(enrolled);

        // Cargar progreso de todos los cursos en paralelo
        if (enrolled.length > 0) {
          const progressResults = await Promise.all(
            enrolled.map(async (course) => {
              try {
                const lessons = await lessonsService.getByCourse(course.id);
                const lessonIds = (lessons || []).map((l) => l.id);
                const completed = await lessonProgressService.getCompleted(lessonIds).catch(() => []);
                return {
                  courseId: course.id,
                  total: lessonIds.length,
                  completed: completed.length,
                  pct: lessonIds.length > 0
                    ? Math.round((completed.length / lessonIds.length) * 100)
                    : 0,
                };
              } catch {
                return { courseId: course.id, total: 0, completed: 0, pct: 0 };
              }
            })
          );
          const map = {};
          progressResults.forEach((r) => { map[r.courseId] = r; });
          setProgressMap(map);
        }
      } catch (error) {
        console.error('Error cargando cursos:', error);
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };
    loadCourses();
  }, []);

  const filtered = courses.filter(
    (c) =>
      c.titulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (c.descripcion || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="dashboard-page">
      <Header />

      <div className="dashboard-container">
        <section className="welcome-section">
          <h1>Bienvenido a Academia 🎓</h1>
          <p>Aquí están los cursos asignados a tu cuenta</p>
        </section>

        <section className="search-section">
          <input
            type="text"
            placeholder="🔍 Buscar en mis cursos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </section>

        <section className="courses-section">
          <h2>Mis Cursos</h2>

          {loading ? (
            <div className="no-courses"><p>⏳ Cargando cursos...</p></div>
          ) : filtered.length > 0 ? (
            <div className="courses-grid">
              {filtered.map((course) => (
                <CourseCard
                  key={course.id}
                  course={course}
                  progress={progressMap[course.id]}
                />
              ))}
            </div>
          ) : (
            <div className="no-courses">
              {courses.length === 0 ? (
                <>
                  <p>📭 No tienes cursos asignados aún</p>
                  {isAdmin && <p style={{fontSize:'13px',color:'#999'}}>Ve al panel Admin → Usuarios para asignar cursos</p>}
                </>
              ) : (
                <p>No se encontraron cursos que coincidan</p>
              )}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default DashboardPage;
